export const processCoulombData = (data) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  return data.map(row => ({
    ...row,
    battery_current: (row.battery_current / 1024) * 3,
    shunt_current: (row.shunt_current / 1024) * 3,
    timestamp: row.timestamp // preserve original timestamp
  }));
};

// Helper function to get total values if needed
export const calculateTotalCurrents = (processedData) => {
  return processedData.reduce((acc, row) => {
    return {
      totalBatteryCurrent: acc.totalBatteryCurrent + row.battery_current,
      totalShuntCurrent: acc.totalShuntCurrent + row.shunt_current
    };
  }, { totalBatteryCurrent: 0, totalShuntCurrent: 0 });
};

export default {
  processCoulombData,
  calculateTotalCurrents
};
